import {ExchangePageProps, ExchangePage} from "../../../Components";

interface Order {
    id: number,
    limit: number,
    orderQty: number,
    direction: string,
}
export const BittrexConfigPage = () => {
    const props: ExchangePageProps<Order> = {
        getId: (order) => order.id,
        getPrice: (order) => order.limit,
        getAmount: (order) => order.quantity,
        isAsk: (order) => order.direction !== 'BUY',
        getQuoteCurrency: () => '',
        configFields: {
            "api_key": "Api Key",
            "api_secret": "Api Secret Key",
            "api_subaccount_id": "Api Subaccount Id (Optional)",
        },
        exchange: "bittrex",
    }

    return <ExchangePage {...props} />
}
